<div class="tile-wrapper">
  <div class="status-icon">

    <img *ngIf="showStatusBadge" src='{{ "assets/images/icons/corner-tab-" + (project.status | lowercase) +".svg"}}' />
    <span><app-tag [title]="project.status"></app-tag></span>
    <mat-icon class="refresh-icon"
      *ngIf="project.status === projectStatusEnum.CREATED.toString() && project.fabricWorkspaceConfigured && project.doesFabricJobExist && !project.isFabricJobCompleted"
      (click)="checkFabricJobStatus()">refresh</mat-icon>
  </div>
  <div class="vertical-dot-menu">
    <button mat-icon-button [matMenuTriggerFor]="projectConfigMenu.menu">
      <mat-icon class="dot-menu-icon">more_vert</mat-icon>
    </button>
    <app-project-config-menu [project]="project" #projectConfigMenu="projectConfigMenu"></app-project-config-menu>
  </div>
  <div class="h5 tooltip-host">
    <span class="cell-text" [matTooltip]="project.projectTitle" matTooltipClass="lengthy-tooltip"
      matTooltipPosition="below" [matTooltipPositionAtOrigin]="true" (click)="navigateToProjectDashboard()">
      {{ project.projectTitle }}
    </span>
  </div>
  <div class="details-wrapper">
    <div class="details size-50">
      <span class="title">Project Type</span>
      <span class="value tooltip-host">
        <span class="cell-text" [matTooltip]="project.projectType" matTooltipClass="lengthy-tooltip"
          matTooltipPosition="below" [matTooltipPositionAtOrigin]="true">
          {{ project.projectType }}
        </span>
      </span>
    </div>
    <div class="details size-50">
      <span class="title">Solution Offering</span>
      <span class="value"><span [matTooltip]="project.solutionOffering">{{project.solutionOffering === '' ?
          'Awaiting configuration' : project.solutionOffering}}</span></span>
    </div>
  </div>
  <div class="details">
    <span class="title">Project Team</span>
    <app-stacked-user-avatars [users]="project.projectTeam" [cramped]="true"></app-stacked-user-avatars>
  </div>
</div>